module.exports = __webpack_public_path__ + "img/silver.2452d41f.png";